<template>
  <div v-if="items.length">
    <p v-if="title" class="text-strong-body text-grey-header mb-16">{{ title }}</p>
    <div class="flex flex-wrap gap-16">
      <tag-label v-for="(item, index) in items" :key="index" :item="item" />
    </div>
  </div>
</template>

<script lang="ts">
import TagLabel from '../tag_label/TagLabel.vue';

interface TagItem {
  text: string;
  icon?: any;
}

export default {
  name: 'TagLabelGroup',
  components: {
    TagLabel,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array as () => TagItem[],
      required: true,
    },
  },
};
</script>
